import { IOfferState } from '../../types/reducers/offer';

/**
 *
 * @description Проверяет, выбрана ли категория "Продажа квартиры в ЖК".
 */
export function checkJKCategory(offer: IOfferState): boolean {
  const { category } = offer;

  return category === 'newBuildingFlatSale';
}
